/**********************************

  worldpantry-inventory.js   (EOC)

  Cookie helpers + the "No Error" self-heal + live product-inventory
  functions + the single auto-trigger that fires a zip lookup on load
  when a zipcode cookie already exists.

  ZIP ACQUISITION: handled solely by assets/worldpantry-ipzipcode.js
  (the boss's app-proxy file -- key stays server-side). The old inline
  IPStack call and its exposed access_key have been REMOVED.

  Shipping submit/display logic lives in snippets/fast-shipping-logic.liquid.

***********************************/

/* ============================================================
   CONFIG -- per-site values.
   ============================================================ */
var WP_INV = {
  endpointKey: 'wp_2022_eightoclock',
  inventoryUrlSingle: 'https://shop.worldpantry.com/productinventories/eightoclock/productinventory.aspx',
  inventoryUrlBatch:  'https://shop.worldpantry.com/productinventories/eightoclock/productinventories.aspx',

  cookies: {
    zip:       'zipcode',
    fsZip:     'FastShip.ZipCode',
    receiveBy: 'FastShip.ReceiveByDateTime',
    orderBy:   'FastShip.OrderByDateTime',
    calcError: 'FastShip.FastShipCalculationError'
  },

  // Auto-trigger hooks (the form lives in the shared snippet markup).
  zipInputSelector:  '.zip_input',
  formSelector:      'form.js-fs-form',

  outOfStockDisplay: 'Usually ships within 1-2 weeks',
  // cta_order_by is a CLASS (not id) and starts visibility:hidden so the
  // date line never flickers in empty and multiple in-stock variants do
  // not create duplicate ids.
  inStockDisplay: "In Stock</br><div class='cta_order_by' style='visibility:hidden;'> For your area - Arrives <strong class='arrival_month'><span></span></strong></div>"
};

/**********************************
  Cookie functions
***********************************/
function setSessionCookie(name, value) {
  document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; SameSite=Strict; Secure";
}

function getSessionCookie(name) {
  const nameKey = name + "=";
  const cArr = document.cookie.split('; ');
  let res;
  cArr.forEach(val => {
    if (val.indexOf(nameKey) === 0) res = decodeURIComponent(val.substring(nameKey.length));
  });
  return res;
}

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict; Secure";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  var encodedValue = value != null ? encodeURIComponent(value) : "";
  document.cookie = name + "=" + encodedValue + expires + "; path=/; SameSite=Strict; Secure";
}

function isValidZip(str) {
  return /^\d{5}(-\d{4})?$/.test(str || "");
}

/**********************************
  One-time self-heal for a stuck error banner.
  Clears the error cookie when its value is "No Error" (success), or
  when there is no valid zip beside it (came from a blank auto-submit).
  Also clears any stale date cookie that is not parseable ISO (legacy
  "June 11" format would otherwise make the banner revert in Firefox).
***********************************/
(function selfHealFastShipCookies() {
  var err = getSessionCookie(WP_INV.cookies.calcError);
  if (err) {
    var zip = getSessionCookie(WP_INV.cookies.fsZip);
    if (err === "No Error" || !isValidZip(zip)) {
      deleteCookie(WP_INV.cookies.calcError);
    }
  }
  // Legacy non-ISO date cookies -> clear so they re-fetch as ISO.
  var receiveBy = getSessionCookie(WP_INV.cookies.receiveBy);
  var orderBy = getSessionCookie(WP_INV.cookies.orderBy);
  if ((receiveBy && isNaN(new Date(receiveBy))) ||
      (orderBy && isNaN(new Date(orderBy)))) {
    deleteCookie(WP_INV.cookies.receiveBy);
    deleteCookie(WP_INV.cookies.orderBy);
  }
})();

/**********************************
  Auto-trigger. The boss's worldpantry-ipzipcode.js sets the `zipcode`
  cookie (server-side proxy, key hidden). If it is present, prefill the
  zip inputs and submit the shared form to run the lookup. Single
  auto-trigger for the site -- the old setTimeout(geoTarget,1000) and the
  inline IPStack call are gone.
***********************************/
$(document).ready(function () {
  var zip = getCookie(WP_INV.cookies.zip);
  if (!isValidZip(zip)) {
    console.log("no valid zipcode yet - skipping auto lookup");
    return;
  }
  console.log("fast geo zip " + zip);
  $(WP_INV.zipInputSelector).val(zip);
  $(WP_INV.formSelector).first().submit();
});

/**********************************
  Product Inventory functions
***********************************/
const OutOfStockAlwaysSellStatusDisplay = WP_INV.outOfStockDisplay;
const InStockAlwaysSellStatusDisplay = WP_INV.inStockDisplay;

function getProductInventoryDisplay(zip, productId, variantId, setProductInventoryStatus) {
  var postproductinventory = $.post(WP_INV.inventoryUrlSingle, {
    zip: zip,
    key: WP_INV.endpointKey,
    productid: productId,
    variantid: variantId,
  });
  postproductinventory.done(function (data) {
    if (data) {
      if (data.Status == "OutOfStock") {
        data.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
      }
      setProductInventoryStatus(data);
    }
  });
}

function getProductNumbers() {
  var productNumbers;
  $.ajax({
    type: "GET",
    url: "/cart?view=wp-productnumbers",
    async: false,
  }).done(function (response) {
    productNumbers = JSON.parse(response);
  });
  return productNumbers;
}

function getProductInventories(productNumbers) {
  var items = [];
  var productInventories;
  for (i = 0; i < productNumbers.length; i++) {
    let item = {};
    item["productId"] = productNumbers[i].productNumber;
    item["variantId"] = productNumbers[i].variantNumber;
    items.push(item);
  }

  if (items) {
    var shippingInfo = new Object();
    shippingInfo.zip = getCookie(WP_INV.cookies.zip);
    shippingInfo.items = items;
    $.ajax({
      type: "POST",
      url: WP_INV.inventoryUrlBatch,
      data: {
        key: WP_INV.endpointKey,
        shippingInfo: JSON.stringify(shippingInfo),
      },
      async: false,
    }).done(function (data) {
      productInventories = data;
    });
  }
  return productInventories;
}

function showProductInventoryCartStatusDisplay(productInventories) {
  var showInventoryCartStatusDisplay = false;
  if (productInventories) {
    for (i = 0; i < productInventories.length; i++) {
      if (productInventories[i].Status == "OutOfStock") {
        showInventoryCartStatusDisplay = true;
        break;
      }
    }
  }
  return showInventoryCartStatusDisplay;
}

function getProductInventory(id, productNumbers, productInventories) {
  var inventoryStatus;
  for (n = 0; n < productNumbers.length; n++) {
    if (productNumbers[n].id == id) {
      var productNumber = productNumbers[n].productNumber;
      var variantNumber = productNumbers[n].variantNumber;
      for (i = 0; i < productInventories.length; i++) {
        if (
          productInventories[i].ProductId &&
          productInventories[i].VariantId &&
          productInventories[i].ProductId.toUpperCase() == productNumber.toUpperCase() &&
          productInventories[i].VariantId.toUpperCase() == variantNumber.toUpperCase()
        ) {
          inventoryStatus = productInventories[i];
          if (inventoryStatus.Status == "OutOfStock") {
            inventoryStatus.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
          } else {
            inventoryStatus.StatusDisplay = InStockAlwaysSellStatusDisplay;
          }
          break;
        }
      }
      break;
    }
  }
  return inventoryStatus;
}
